import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SETTINGS WATERMARK FILES TO EDIT ********************
export const fetchSettingsWatermark = (id, WatermarkMediaType) => async (
	dispatch
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SETTINGS_LOGO_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=${WatermarkMediaType}&collection=logo`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SETTINGS_LOGO_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SETTINGS_LOGO_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
